export const authConfig = {
  domain: process.env.REACT_APP_DOMAIN,
  clientId: process.env.REACT_APP_CLIENTID,
  audience: process.env.REACT_APP_AUDIENCE,
};
